module.exports = __webpack_public_path__ + "media/theme/arrow-4-acad9b23.png";